<template>
    <div class="uk-grid" data-uk-grid-margin>
        <div class="uk-width-1-1">
            <textarea v-if="can_edit_data" class="uk-width-1-1" placeholder="Add a comment..." v-model="comment"></textarea>
            <div v-if="!!comment.length" class="uk-grid uk-grid-small uk-text-center uk-margin-top">
                <div class="uk-width-1-2">
                    <a href class="uk-button uk-width-1-1" @click.prevent="clear_comment">Cancel</a>
                </div>
                <div class="uk-width-1-2">
                    <a href class="uk-button uk-button-primary uk-width-1-1" @click.prevent="save_comment">Submit Comment</a>
                </div>
            </div>

            <div class="uk-overflow-container lam-comments-list" :class="{'uk-margin-top': can_edit_data}">
                <ul v-if="comments.length" class="uk-list uk-list-line">
                    <li v-for="comment in sorted_comments" :key="comment.id">
                        <div v-html="comment.content" v-linkified></div>
                        <div class="uk-text-muted">
                            <small>
                                <open-icon glyph="clock-o" /> {{ comment.created_at | nibnut.date_from_now }}, by {{ comment.author }}
                                <a v-if="can_or_db_admin(this.profile && (this.profile.id===comment.user_id))" href="#" class="uk-icon-hover uk-icon-trash" @click.prevent="remove_comment(comment)"></a>
                            </small>
                        </div>
                    </li>
                </ul>
                <div v-else class="uk-text-center"><em class="uk-text-muted">(No comments)</em></div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"
import { orderBy } from "lodash"

import linkify from "vue-linkify"

import profile_utilities from "../mixins/ProfileUtilities"

import OpenIcon from "./OpenIcon"

export default {
    mixins: [profile_utilities],
    components: {
        OpenIcon
    },
    directives: {
        linkified: linkify
    },
    methods: {
        clear_comment () {
            this.comment = ""
        },
        save_comment () {
            this.$store.dispatch("CREATE_RECORD", {
                entity: "comment",
                data: {
                    topic_id: this.ownerId,
                    topic_type: this.ownerType.replace(/\./g, "\\"),
                    user_id: this.profile_id,
                    content: this.comment
                }
            }).then(() => {
                this.clear_comment()
            }).catch(error => {
                this.$error(error.message)
            })
        },
        remove_comment (comment) {
            this.$confirm({
                type: "error",
                title: "Delete Comment",
                message: `Do you really want to delete this comment by ${comment.author}? There is no undo...`,
                cancel: "Keep It",
                ok: "Delete It",
                then: (confirmed) => {
                    if(confirmed) {
                        this.$store.dispatch("RECORD_DELETE", {
                            entity: "comment",
                            id: comment.id
                        }).catch(error => {
                            if(error) this.$error(error.message)
                        })
                    }
                }
            })
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_comment_records () {
            return this.entity_records("comment")
        },
        can_edit_data () {
            return !!this.profile && this.editable
        },
        comments () {
            if(this.sourcedComments) return this.sourcedComments
            if(!this.ownerId) return []
            return this.raw_comment_records.filter(comment => {
                return (comment.topic_id === this.ownerId) && (comment.topic_type === this.ownerType.replace(/\./g, "\\"))
            })
        },
        sorted_comments () {
            if(!this.comments) return []
            return orderBy(this.comments, "created_at", "desc")
        }
    },
    props: {
        ownerId: {
            type: Number,
            required: true
        },
        ownerType: {
            type: String,
            required: true
        },
        sourcedComments: {
            validator: prop => !prop || Array.isArray(prop),
            default () {
                return null
            }
        },
        editable: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            comment: ""
        }
    }
}
</script>
